import React from 'react'
import { baseUrl } from '@fs/zion-config'
import StructuredData from './StructuredData'
import { getOrganizationData, getRootsTechOrganizationData } from './OrganizationStructuredData'
import { getPlaceData } from './PlaceStructuredData'
import { registrationConfig } from '../../config'

export const getCourseOfferData = (data) => {
  return {
    '@type': 'Offer',
    url: data.url,
    price: '0.00',
    priceCurrency: 'USD',
    availability: 'https://schema.org/InStock',
    category: 'https://schema.org/OnlineEventAttendanceMode',
    seller: getRootsTechOrganizationData(),
    eligibleRegion: getPlaceData({ name: 'Worldwide' }),
    // TODO: check the format of the date "availabilityStarts": "2025-03-01T08:00:00-07:00"
    // availabilityStarts: data.date || (data.conferenceYear ? data.conferenceYear : ''),
    isAvailableForFree: true,
    // NOTE: We should consider adding these based on UGC content, Exhibitor content could be for a year and renewed.
    // validFrom: '2025-03-01T00:00:00Z',
    // validThrough: '2025-06-01T00:00:00Z',
  }
}

export const getInPerson3DayOfferData = () => {
  return {
    '@type': 'Offer',
    name: 'In-Person 3 Day Pass',
    url: `${baseUrl}/rootstech/registration/in-person`,
    price: `${registrationConfig.attendeePricing.standard.threeDay}.00`,
    priceCurrency: 'USD',
    availability: 'https://schema.org/InStock',
    category: 'https://schema.org/OfflineEventAttendanceMode',
    seller: getRootsTechOrganizationData(false),
    // TODO: set these to the next conferences start and end date? Or Registration opening?
    //  validFrom: '2025-03-01',
    // validThrough: '2025-03-05',
  }
}

export const getInPerson1DayOfferData = () => {
  return {
    '@type': 'Offer',
    name: 'In-Person 1 Day Pass',
    url: `${baseUrl}/rootstech/registration/in-person`,
    price: `${registrationConfig.attendeePricing.standard.oneDay}.00`,
    priceCurrency: 'USD',
    availability: 'https://schema.org/InStock',
    category: 'https://schema.org/OfflineEventAttendanceMode',
    seller: getRootsTechOrganizationData(false),
    // TODO: set these to the next conferences start and end date? Or Registration opening?
    //  validFrom: '2025-03-01',
    // validThrough: '2025-03-05',
  }
}

export const getOnlineOfferData = ({ url = `${baseUrl}/rootstech/registration/online` } = {}) => {
  return {
    '@type': 'Offer',
    name: 'Online Pass',
    url,
    price: '0.00',
    priceCurrency: 'USD',
    availability: 'https://schema.org/OnlineOnly',
    category: 'https://schema.org/OnlineEventAttendanceMode',
    seller: getRootsTechOrganizationData(false),
    eligibleRegion: getPlaceData({ name: 'Worldwide' }),
    isAccessibleForFree: true,
    // TODO: set these to the next conferences start and end date? Or Registration opening?
    //  validFrom: '2025-03-01',
    // validThrough: '2025-03-05',
  }
}

export const get365OnlineOfferData = () => {
  return {
    '@type': 'Offer',
    name: 'Online Pass',
    price: '0.00',
    priceCurrency: 'USD',
    availability: 'https://schema.org/OnlineOnly',
    category: 'https://schema.org/OnlineEventAttendanceMode',
    seller: getRootsTechOrganizationData(false),
    isAccessibleForFree: true,
    // TODO: set these to the next conferences start and end date? Or Registration opening?
    //  validFrom: '2025-03-01',
    // validThrough: '2025-03-05',
  }
}

export const getDiscoveryDayOfferData = () => {
  return {
    '@type': 'Offer',
    name: 'Family Discovery Day Pass',
    url: `${baseUrl}/rootstech/registration/in-person/discovery-day`,
    price: '0.00',
    priceCurrency: 'USD',
    // TODO: once the conference is over, we should set this to OutOfStock
    availability: 'https://schema.org/InStock',
    category: 'https://schema.org/OfflineEventAttendanceMode',
    isAvailableForFree: true,
    // TODO: set these to the next conferences start and end date? Or Registration opening?
    //  validFrom: '2025-03-01',
    // validThrough: '2025-03-05',
  }
}

export const getPromotionOfferData = (data) => {
  const exhibitor = data?.exhibitor ?? null
  return {
    '@type': 'Offer',
    name: data?.title ?? data?.headingText,
    description: data.description,
    url: data.url,
    availability: 'https://schema.org/InStock',
    offeredBy: getRootsTechOrganizationData(),
    seller: getOrganizationData(exhibitor),
    // TODO: set these to the start and end date or promotions.
    // validFrom: '2025-03-01',
    // validThrough: '2025-03-05',
  }
}

export const getOfferData = (data) => {
  const seller = data ? getOrganizationData(data) : getRootsTechOrganizationData()
  return {
    '@type': 'Offer',
    name: data?.name,
    price: '0.00',
    priceCurrency: 'USD',
    availability: 'https://schema.org/InStock',
    seller,
    eligibleRegion: getPlaceData({ name: 'Worldwide' }),
    // NOTE: We should consider adding these based on UGC content, Exhibitor content could be for a year and renewed.
    // validFrom: '2025-03-01T00:00:00Z',
    // validThrough: '2025-06-01T00:00:00Z',
  }
}

export default function OfferStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getOfferData(data)
  return <StructuredData data={structuredData} dataTestId="offer-structured-data" />
}
